@if (variant === 'grid') {
  <div
    class="row row-cols-2 row-cols-sm-3 row-cols-md-3 row-cols-lg-3 row-cols-xl-4 justify-content-center g-2 p-0">
    @for (link of pagedLinks; track link; let i = $index) {
      <app-tooltip [text]="link.name + ' | ' + link.url" [opensOn]="'Auto'" [position]="'TopCenter'">
        <div class="d-flex">
          <div class="link-card d-flex align-items-center flex-grow-1 p-1" (click)="onLinkClick(link)">
            <span class="link-text text-primary px-1 flex-grow-1 truncate-text-one-line">{{ link.name }}</span>
          </div>
        </div>
      </app-tooltip>
    }

    @for (placeholder of placeholders; track placeholder) {
      <div class="d-flex" style="visibility: hidden;">
        <div class="link-card d-flex align-items-center flex-grow-1 p-1">
          <div class="icon-background"></div>
          <span class="link-text flex-grow-1 truncate-text-one-line">&nbsp;</span>
        </div>
      </div>
    }
  </div>
} @else {
  <div class="quick-nav-list mt-2">
    @for (link of pagedLinks; track link.id) {
      <app-tooltip [text]="link.name + ' | ' + link.url" [opensOn]="'Auto'" [position]="'TopCenter'">
        <button
          type="button"
          class="card move-page-card mb-0 quick-nav-link-row text-start"
          [attr.aria-label]="link.name"
          (click)="onLinkClick(link)"
          (keydown)="onLinkKeydown($event, link)">
          <div class="d-flex align-items-center justify-content-between h-100">
            <div class="name-column d-flex align-items-center flex-grow-1 px-2 h-100 min-w-0">
              <span class="mts-icon me-2 text-primary notranslate" translate="no">link</span>
              <span class="fs-small fw-semibold truncate-text-one-line text-muted">{{ link.name }}</span>
            </div>
            <div class="checkbox-column d-flex align-items-center justify-content-center border-start h-100">
              <span class="mts-icon p-2 notranslate" translate="no">chevron_right</span>
            </div>
          </div>
        </button>
      </app-tooltip>
    }
  </div>
}

@if (showPagination && pageNumbers.length > 1) {
  <div class="my-3">
    <nav [attr.aria-label]="'LINKPAGINATIONARIALABEL' | translate" class="d-flex align-items-center justify-content-center">
      <ul class="pagination pagination-sm justify-content-center mb-0">
        <li class="page-item" [class.disabled]="page <= 1">
          <button
            type="button"
            class="page-link e-prevent-select"
            [disabled]="page <= 1"
            (click)="onPageClick(page - 1)">
            {{ 'PREVIOUS' | translate}}
          </button>
        </li>
        <li class="page-item disabled">
          <span class="page-link e-prevent-select">
            {{ page }} / {{ pageNumbers.length }}
          </span>
        </li>
        <li class="page-item" [class.disabled]="page >= pageNumbers.length">
          <button
            type="button"
            class="page-link e-prevent-select"
            [disabled]="page >= pageNumbers.length"
            (click)="onPageClick(page + 1)">
            {{ 'NEXT' | translate}}
          </button>
        </li>
      </ul>
    </nav>
  </div>
}
